module.exports = __webpack_public_path__ + "static/testimonial-7-33f447d2bae92232de19fdf7db44525f.png";